export * from './DiagnosisSearch';
export { default } from './DiagnosisSearch';
